import React, { useEffect, useState } from "react";
import "./BasicSlider.css";


const images = [
  "/images/building1.jpg",
  "/images/office.jpg",
  "/images/building.avif",
  "/images/cc3.png",
];

const ImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 2000); 
    return () => clearInterval(interval); 
  }, [currentIndex]);


  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

 
  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="slider-container">
      
      <div className="text-section">
        <h1>DataDisca is specialised in AI</h1>
        <p>Experts in algorithm development to achieve your goal.</p>
      </div>

      <div className="slider">
        
        <img src={images[currentIndex]} alt="slide" className="slide-image" />

        
        <button className="prev-button" onClick={prevSlide}>
          &#10094;
        </button>
        <button className="next-button" onClick={nextSlide}>
          &#10095;
        </button>

        
        <div className="dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageSlider;
